export default "__VITE_ASSET__CinBJDVF__"